import { CommonEnums } from '../../common.enums';

export class DxFlow_Obj_Property {
	dxFlow_Id: number;
	job_Id: number;
	property_Id: number;
	property_Cd: string;
	property_Nm: string;
	property_Val: string;
	srt_Order: number;
	property_Type: string;

	constructor() {
		this.setDefaults();
	}

	setDefaults(): void {
		this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
		this.job_Id = CommonEnums.defaults.LONG_VAL;
		this.property_Id = CommonEnums.defaults.LONG_VAL;
		this.property_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.property_Nm = CommonEnums.defaults.STRING_EMPTY;
		this.property_Val = CommonEnums.defaults.STRING_EMPTY;
		this.srt_Order = CommonEnums.defaults.LONG_VAL;
		this.property_Type = CommonEnums.defaults.STRING_EMPTY;
	}

	static parse(dxFlow_Obj_PropertyTmp: any): DxFlow_Obj_Property {
		let dxFlow_Obj_Property: DxFlow_Obj_Property = new DxFlow_Obj_Property();
		dxFlow_Obj_Property.copyFrom(dxFlow_Obj_PropertyTmp as DxFlow_Obj_Property);
		return dxFlow_Obj_Property;
	}

	getPrimaryKey(): string {
		return this.dxFlow_Id + '.' + this.job_Id + '.' + this.property_Cd;
	}

	copy(): DxFlow_Obj_Property {
		let dxFlow_Obj_PropertyTmp: DxFlow_Obj_Property = new DxFlow_Obj_Property();

		dxFlow_Obj_PropertyTmp.dxFlow_Id = this.dxFlow_Id;
		dxFlow_Obj_PropertyTmp.job_Id = this.job_Id;
		dxFlow_Obj_PropertyTmp.property_Id = this.property_Id;
		dxFlow_Obj_PropertyTmp.property_Cd = this.property_Cd;
		dxFlow_Obj_PropertyTmp.property_Nm = this.property_Nm;
		dxFlow_Obj_PropertyTmp.property_Val = this.property_Val;
		dxFlow_Obj_PropertyTmp.srt_Order = this.srt_Order;
		dxFlow_Obj_PropertyTmp.property_Type = this.property_Type;

		return dxFlow_Obj_PropertyTmp;
	}

	copyFrom(dxFlow_Obj_PropertyTmp: DxFlow_Obj_Property): void {
		this.dxFlow_Id = dxFlow_Obj_PropertyTmp.dxFlow_Id;
		this.job_Id = dxFlow_Obj_PropertyTmp.job_Id;
		this.property_Id = dxFlow_Obj_PropertyTmp.property_Id;
		this.property_Cd = dxFlow_Obj_PropertyTmp.property_Cd;
		this.property_Nm = dxFlow_Obj_PropertyTmp.property_Nm;
		this.property_Val = dxFlow_Obj_PropertyTmp.property_Val;
		this.srt_Order = dxFlow_Obj_PropertyTmp.srt_Order;
		this.property_Type = dxFlow_Obj_PropertyTmp.property_Type;
	}

	compare(dxFlow_Obj_PropertyTmp: DxFlow_Obj_Property): string {
		let dxFlow_Obj_PropertyString: string = this.toString(false);
		let dxFlow_Obj_PropertyTmpString: string = dxFlow_Obj_PropertyTmp.toString(false);

		if (dxFlow_Obj_PropertyString != dxFlow_Obj_PropertyTmpString) {
			return dxFlow_Obj_PropertyString + ', ' + dxFlow_Obj_PropertyTmpString;
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "DxFlow_Obj_Property [dxFlow_Id=" + this.dxFlow_Id + ", job_Id=" + this.job_Id +
			", property_Id=" + this.property_Id + ",property_Cd=" + this.property_Cd +
			", property_Nm=" + this.property_Nm + ", property_Val=" + this.property_Val +
			", srt_Order=" + this.srt_Order + ", property_Type=" + this.property_Type;

		if (isNotCompare) {
			str += ''
		}

		str += ']';
		return str;
	}
}	
